// User photos
export const PHOTOS = {
  hero: "https://customer-assets.emergentagent.com/job_tulsi-home/artifacts/vf1765f5_Tulsi.jpeg",
  formal: "https://customer-assets.emergentagent.com/job_tulsi-home/artifacts/cpq6jhi2_Tulsi%20.jpeg",
  workshop: "https://customer-assets.emergentagent.com/job_tulsi-home/artifacts/em26nmdt_2025-10_FoodHaus__CHA2867.jpg",
  kheti: "https://customer-assets.emergentagent.com/job_tulsi-home/artifacts/qrhomdiu_1690206123408.jpeg",
  speaking: "https://customer-assets.emergentagent.com/job_tulsi-home/artifacts/w05yhz4j_2025-10_FoodHaus_DSC00212.jpg",
  policy: "https://customer-assets.emergentagent.com/job_tulsi-home/artifacts/tlrez1r6_MAC24%20group%20picture.jpg",
  crossCultural: "https://customer-assets.emergentagent.com/job_tulsi-home/artifacts/h767296u_IMG_2305.jpg",
};

// Organization links
export const ORG_LINKS = {
  developmentVoyage: "https://developmentvoyage.com",
  kheti: "https://kheti.com.np",
  sarvaguna: "https://sarvaguna.com.np",
  foodNetworks: "https://foodnetworks.ch",
  linkedin: "https://www.linkedin.com/in/tulsi-giri-91448517",
};

// OG Image URL
export const OG_IMAGE = "https://tulsigiri.com/og-image.jpg";
